import {Injectable} from '@angular/core';
import {emptyAuthServiceResponse, emptyValidateTokenServiceResponse, IAuthServiceResponse, ILogoutServiceResponse, IValidateTokenServiceResponse} from "@retail-data-factory/rdf-angular-types-api";
import {Observable, of, throwError} from "rxjs";
import {TOidcProviderType} from "../../../../store/app-store/models/security/authentication.interface";
import {ApiService} from "../../../../services/external-api/api.service";
import {catchError, map} from "rxjs/operators";
import {emptyRdfServiceResponseError, IRdfServiceResponseError, IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class ApiAuthenticationService {

  constructor(
    private apiService: ApiService,
    private configurationManager: ConfigurationManager
  ) {
  }

  authenticateByLogin(login: string, password: string): Observable<IAuthServiceResponse> {
    const url = this.configurationManager.getApiUrl('apiAuthUrl') + '/authenticate';
    const requestHeader = {
      login: login,
      password: encodeURIComponent(password),
      realm: this.configurationManager.configuration.auth.realm,
      module: this.configurationManager.configuration.auth.module
    };
    return this.apiService.get(url, requestHeader).pipe(
      map((data: IAuthServiceResponse) => {
          console.log('authentication - done', data);
          const accToken = data.access_token;
          if (!data.Error && accToken) {
            window.localStorage.setItem('access_token', accToken);
            console.log(`set local storage token = ${accToken}`);
          } else {
            //todo: Throw error
            window.localStorage.removeItem('access_token');
            window.localStorage.removeItem('workflow_token');
          }
          return data;
        }
      ),
      catchError((error) => {
          const err: IRdfServiceResponseError = this.apiService.mapHttpErrorToRdfError('GET', error, url, requestHeader, {});
          return throwError(err);
        }
      )
    );
  }

  authenticateByLoginInternal(login: string, password: string): Observable<IAuthServiceResponse> {
    const url = this.configurationManager.getApiUrl('apiAuthUrl') + '/authenticate';
    const requestHeader = {
      login: login,
      password: encodeURIComponent(password),
      realm: this.configurationManager.configuration.auth.realm,
      module: this.configurationManager.configuration.auth.module
    };
    return this.apiService.get(url, requestHeader).pipe(
      map((data: IAuthServiceResponse) => {
          return data;
        }
      ),
      catchError((error) => {
          const err: IRdfServiceResponseError = this.apiService.mapHttpErrorToRdfError('GET', error, url, requestHeader, {});
          return throwError(err);
        }
      )
    );
  }



  authenticateByOidcProvider(oidcAccessToken: string, oidcProviderType: TOidcProviderType): Observable<IAuthServiceResponse> {
    return of(emptyAuthServiceResponse);
  }

  authenticateByGoogle(oidcAccessToken: string):  Observable<IAuthServiceResponse> {
    return this.apiService.get(this.configurationManager.getApiUrl('apiAuthUrl') + '/authenticategoogle', {
      oidc_id_token: oidcAccessToken
    }).pipe(
      map((data: IServiceResponse)=>{

        const accToken = data['access_token'];

        if (!data.Error && accToken) {
          window.localStorage.setItem('access_token', accToken);
          console.log(`set local storage token = ${accToken}`);
        } else {
          //todo: Throw error
          window.localStorage.removeItem('access_token');
          window.localStorage.removeItem('workflow_token');
        }


        const result: IAuthServiceResponse = {
          ...emptyAuthServiceResponse,
          access_token: data['access_token'],
          Msg: data.Msg,
          Error: data.Error,
          Version: data.Version
        };
        return result;
      })
    );
  }

  logout(accessToken: string): Observable<ILogoutServiceResponse> {
    const url = this.configurationManager.getApiUrl('apiAuthUrl') + '/logout';
    const requestHeader ={access_token: accessToken};
    return this.apiService.get(url, requestHeader).pipe(
      map((data: ILogoutServiceResponse) => {
        if (data.Error!==0) {
          const error: IRdfServiceResponseError = {
            ...emptyRdfServiceResponseError,
            errorCode: data.Error,
            msg: data.Msg,
            url: url,
            requestParams: requestHeader
          };
          console.error(error);
          throwError(error);
        }
        return data;
      }),
      catchError((error) => {
          const err: IRdfServiceResponseError = this.apiService.mapHttpErrorToRdfError('GET', error, url, requestHeader, {});
          return throwError(err);
        }
      )
    );
  }

  validateToken(accessToken: string): Observable<IValidateTokenServiceResponse> {
    const url = this.configurationManager.getApiUrl('apiAuthUrl') + '/logout';
    const requestHeader ={access_token: accessToken, 'access-token': accessToken};
    return this.apiService.get(this.configurationManager.getApiUrl('apiAuthUrl') + '/validate', {
      'access_token': accessToken,
      'access-token': accessToken
    }).pipe(
      map((data: IValidateTokenServiceResponse) => {
        if (data.Error!==0) {
          const error: IRdfServiceResponseError = {
            ...emptyRdfServiceResponseError,
            errorCode: data.Error,
            msg: data.Msg,
            url: url,
            requestParams: requestHeader
          };
          console.error(error);
          throwError(error);
        }
        return data;
      }),
      catchError((error) => {
          const err: IRdfServiceResponseError = this.apiService.mapHttpErrorToRdfError('GET', error, url, requestHeader, {});
          return throwError(err);
        }
      )
    );
  }


}
